import { conversionRates } from 'common/constants';

function timer(callback, value, delay = 500) {
	setTimeout(() => {
		callback(value);
	}, delay);
}

function isNumber(value) {
	if (value === '') {
		return false;
	}
	return !isNaN(Number(value));
}

function getDecimalPounds(pounds, ounces) {
	if (isNumber(pounds) && isNumber(ounces))
		return (parseInt(pounds) + parseInt(ounces) / conversionRates.poundsAndOunces).toFixed(2);
	if (isNumber(pounds)) return parseFloat(pounds).toFixed(2);
	if (isNumber(ounces)) return (ounces / conversionRates.ouncesAndKilograms).toFixed(2);

	return '';
}

function getPounds(decimalPounds) {
	if (isNumber(decimalPounds) && parseInt(decimalPounds) > 0) return parseInt(decimalPounds);
	return '';
}

function getOunces(decimalPounds) {
	if (isNumber(decimalPounds) && decimalPounds % 1 != 0)
		return parseInt((decimalPounds % 1) * conversionRates.poundsAndOunces);
	return '';
}

function getKilograms(pounds, ounces) {
	if (isNumber(pounds) && isNumber(ounces))
		return (pounds * conversionRates.poundsInKilogram + ounces * conversionRates.ouncesAndKilograms).toFixed(2);
	if (isNumber(pounds)) return (pounds * conversionRates.poundsInKilogram).toFixed(2);
	if (isNumber(ounces)) return (ounces * conversionRates.ouncesAndKilograms).toFixed(2);

	return '';
}

function getPoundsAndOuncesFromKilograms(kilograms) {
	if (isNumber(kilograms)) {
		const totalPounds = parseFloat(kilograms * conversionRates.kilogramsAndPounds);
		let pounds = Math.floor(totalPounds);
		let ounces = Math.round((totalPounds % 1) * conversionRates.poundsAndOunces);
		if (ounces === 16) {
			pounds += 1;
			ounces = 0;
		}
		return { pounds: pounds == 0 ? '' : pounds, ounces: ounces == 0 ? '' : ounces };
	}
	return { pounds: '', ounces: '' };
}

export { timer, getDecimalPounds, getKilograms, getPounds, getOunces, getPoundsAndOuncesFromKilograms };



// WEBPACK FOOTER //
// ./src/core/utils/utils.js